import React, { FC } from 'react';
import { Text, Box, Icon, IconSize } from '@bechtel/gds';
import { TimesheetCrewItemProps } from './types';
import { CrewTimesheetIndicatorStyled, NavLinkStyled } from './styled';
import { useName } from '@bechtel/client-common';

export const TimesheetCrewItem: FC<TimesheetCrewItemProps> = ({ timesheetStatusCrewMember }) => {
  const { getFullName } = useName();
  const { crewMember, timesheetStatus } = timesheetStatusCrewMember;
  const isDisable =
    crewMember?.crew?.crewNumber && timesheetStatusCrewMember.crewCount && timesheetStatusCrewMember.crewCount > 0
      ? false
      : true;
  return (
    <NavLinkStyled to={`${timesheetStatusCrewMember.crewMember?.id}`} state={crewMember?.crew} isDisable={isDisable}>
      <Box alignItems={{ sm: 'center' }}>
        <CrewTimesheetIndicatorStyled status={timesheetStatus} />
        <Text size="400" weight="600" color="grey.1000">
          {crewMember?.crew?.crewNumber}
        </Text>
        <Box ml={{ sm: '400' }}>
          <Text size="300" color="grey.600">
            {getFullName(crewMember?.firstName, crewMember?.lastName)}
          </Text>
        </Box>
      </Box>
      <Box justifyContent={{ sm: 'flex-end' }} pr={{ sm: '500' }}>
        <Icon size={IconSize.MEDIUM} icon="chevron-right" fillColor="bechtel.blue.800" />
      </Box>
    </NavLinkStyled>
  );
};
